// extracted by mini-css-extract-plugin
export default {"icon":"LoginPageLogo_icon__55SNJ"};